import SearchService from '../classes/SearchService';
import { UNITS } from '../constants/units';

// min bike height
const minHeight = new SearchService().getHeightRange().min;

// Return first bike render after units switching
export default (unit = UNITS.inches, height = minHeight, factor = UNITS.factor.inches) => unit === UNITS.inches ? Math.floor(height) : parseInt(height * factor, 10) + 1;


// WEBPACK FOOTER //
// ./src/functions/formatRange.js